<template>
    <section class="broodmares-page">
        <h1 id="broodmares" class="print-title">Broodmares with their Produce</h1>
        <p class="text-center">
            Foals arranged under their dams, born {{ yearsRange }}
        </p>
        <p class="text-center">
            <i>(Including some late registrations omitted from previous volumes)</i>
        </p>
        <p class="text-center">
            (The symbol § indicates the sire is a stallion domiciled abroad at the time of breeding)
        </p>
    </section>

    <div class="break-after"></div>

    <div>
        <div class="single-broodmare" v-for="broodmare in broodmares" :key="broodmare.regNr">
            <div class="broodmare-name">
                <span class="horse-name">{{ broodmare.horseName }}</span> {{ addBrackets(broodmare.regNr) }}
            </div>
            <div class="broodmare-details">
                <span v-html="formatBroodmareDetailsHtml(broodmare)"></span>
                {{ broodmare.importYear ? `Imported in ${broodmare.importYear} from ${broodmare.importCountry}. ` : "" }}
                {{ broodmare.studbook ? `See ${broodmare.studbook}.` : "" }}
            </div>
            <table class="broodmare-foals-table">
                <tbody>
                    <tr v-for="foal in broodmare.foals" :key="foal.regNr">
                        <td>{{ foal.yearOfBirth }}</td>
                        <td>{{ foal.dateOfBirth }}</td>
                        <td>{{ foal.color }}.{{ foal.sex }}</td>
                        <td><b class="horse-name">{{ foal.name }}</b> {{ addBrackets(foal.regNr) }}</td>
                        <td>by <span class="horse-name">{{ foal.sireName }}</span> {{ addBrackets(foal.sireRegNr) }}</td>
                        <td>{{ foal.owner }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {yearFromToMixin} from "@/views/readonly/studbook/util/yearFromToMixin";
import {addBracketsMixin} from "@/views/readonly/studbook/util/addBracketsMixin";

export default {
    name: "BroodmaresPage",
    mixins: [yearFromToMixin, addBracketsMixin],
    props: {
        broodmares: Array,
    },
    methods: {
        formatBroodmareDetailsHtml(b) {
            const details = this.formatBroodmareDetails(b);
            return details.length > 0 ? `${details}. ` : "";
        },
        formatBroodmareDetails(b) {
            const parts = [];
            const firstSection = [];
            const secondSection = [];
            const thirdSection = [];

            if (b.color) firstSection.push(b.color);
            if (b.yearOfBirth) firstSection.push(b.yearOfBirth);
            if (b.strain) firstSection.push(b.strain);

            if (b.breeder) secondSection.push(b.breeder);

            if (b.sireName) {
                let sireInfo = `By <span class="horse-name">${b.sireName}</span>`;
                if (b.sireSireName || b.sireDamName) {
                    const sireSireName = b.sireSireName ? `<span class="horse-name">${b.sireSireName}</span>` : "";
                    const sireDamName = b.sireDamName ? `/<span class="horse-name">${b.sireDamName}</span>` : "";
                    sireInfo += ` (${sireSireName}${sireDamName})`;
                }
                thirdSection.push(sireInfo);
            }

            if (b.damName) {
                let damInfo = `out of <span class="horse-name">${b.damName}</span>`;
                if (b.damSireName || b.damDamName) {
                    const damSireName = b.damSireName ? `<span class="horse-name">${b.damSireName}</span>` : "";
                    const damDamName = b.damDamName ? `/<span class="horse-name">${b.damDamName}</span>` : "";
                    damInfo += ` (${damSireName}${damDamName})`;
                }
                thirdSection.push(damInfo);
            }

            parts.push(firstSection.join(", "));
            parts.push(secondSection);
            parts.push(thirdSection.join(", "));

            const partsToReturn = parts.filter((el) => {
                if (Array.isArray(el) && el.length === 0) return false;
                return !(typeof el === "string" && el === "");
            });

            return partsToReturn.join(". ");
        },
    },
};
</script>

<style lang="scss" scoped>

.broodmares-page {
    margin-top: 50% !important;
}
</style>
